export const TEXTS_GACO = {
  es_ES: new Map([
    ['chartNameGacoEjecucion', 'EJECUCIÓN GLOBAL GASTO'],
    ['chartNamePocertEjecArea', 'PORCENTAJE DE EJECUCIÓN POR ÁREA'],
    [
      'chartNameUnidadOrganizativa',
      'EJECUCIÓN MENSUAL POR UNIDAD ORGANIZATIVA',
    ],
    ['area', 'Área'],
    ['fecha', 'Fecha'],
    ['cred_inicial', 'Crédito Inicial'],
    ['cred_modif', 'Crédito Modificado'],
    ['cred_definitivo', 'Crédito Definitivo (€)'],
    ['cred_disponible', 'Crédito Disponible'],
    ['cred_no_disponible', 'Crédito No Disponible'],
    ['cred_retenido', 'Crédito Retenido (€)'],
    ['imp_autorizado', 'Importe Autorizado (€)'],
    ['imp_comprometido', 'Importe Comprometido'],
    ['obl_reconocidas', 'Obligaciones Reconocidas (€)'],
    ['pag_liquidos', 'Pagos Líquidos (€)'],
    ['reintegros', 'Reintegros'],
    ['cred_definit_menos_cred_reten', 'Crédito Definitivo - Crédito Retenido'],
    ['cred_reten_div_cred_defin', 'Crédito Retenido / Crédito Definitivo (%)'],
    [
      'cred_definit_menos_cred_autor',
      'Crédito Definitivo - Crédito Autorizado',
    ],
    ['cred_auto_div_cred_def', 'Crédito Autorizado / Crédito Definitivo (%)'],
    [
      'cred_definit_menos_imp_comprom',
      'Crédito Definitivo - Importe Comprometido',
    ],
    ['imp_compro_div_cred_def', 'Importe Comprometido / Crédito Definitivo (%)'],
    [
      'cred_definit_menos_obli_reconoc',
      'Crédito Definitivo - Obligaciones Reconocidas',
    ],
    [
      'cred_definit_menos_pagos_liquidos',
      'Crédito Definitivo - Pagos Líquidos',
    ],
    ['pagos_liq_div_cred_def', 'Pagos Líquidos / Crédito Definitivo (%)'],
    ['Obl_reconoc_div_cred_definitivo', 'Ejecución mensual (%)'],
    ['reset', 'Restablecer'],
    ['download', 'Descargar'],
  ]),
  ca_ES: new Map([
    ['chartNameGacoEjecucion', 'EXECUCIÓ GLOBAL DESPESA'],
    ['chartNamePocertEjecArea', "PERCENTATGE D'EXECUCIÓ PER ÀREA"],
    ['chartNameUnidadOrganizativa', "PERCENTATGE D'EXECUCIÓ PER ÀREA"],
    ['area', 'Àrea'],
    ['fecha', 'Data'],
    ['cred_inicial', 'Crèdit Inicial'],
    ['cred_modif', 'Crèdit Modificat'],
    ['cred_definitivo', 'Crèdit Definitiu'],
    ['cred_disponible', 'Crèdit Disponible'],
    ['cred_no_disponible', 'Crèdit No Disponible'],
    ['imp_autorizado', 'Import Autoritzat'],
    ['cred_retenido', 'Crèdit Retingut'],
    ['imp_comprometido', 'Import Compromés'],
    ['obl_reconocidas', 'Obligacions Reconegudes'],
    ['cred_auto_div_cred_def', '% Crèdit Autoritzats / Crèdit Definitiu'],
    ['imp_compro_div_cred_def', '% Import Compromés / Crèdit Definitiu'],
    ['pagos_liq_div_cred_def', '% Pagaments Líquids / Crèdit Definitiu'],
    ['pag_liquidos', 'Pagaments Líquids'],
    ['reintegros', 'Reintegraments'],
    ['cred_definit_menos_cred_reten', 'Crèdit Definitiu - Crèdit Retingut'],
    ['cred_reten_div_cred_defin', '% Crèdit Retingut / Crèdit Definitiu'],
    ['cred_definit_menos_cred_autor', 'Crèdit Definitiu - Crèdit Autoritzat'],
    ['Obl_reconoc_div_cred_definitivo', '% Execució mensual'],

    ['cred_definit_menos_imp_comprom', 'Crèdit Definitiu - Import Compromés'],
    [
      'cred_definit_menos_obli_reconoc',
      'Crèdit Definitiu - Obligacions Reconegudes',
    ],
    [
      'cred_definit_menos_pagos_liquidos',
      'Crèdit Definitiu - Pagaments Líquids',
    ],
    ['reset', 'Restablir'],
    ['download', 'Desar'],
  ]),
};
